import * as React from 'react'
import { OnboardingComponentProps } from '.'
import { Text } from '@doordash/design-language'

export const TextComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ children, size, data, ...props }: OnboardingComponentProps) => (
    <Text size={typeof size === 'number' ? size : undefined} {...props}>
      {children}
    </Text>
  )
)
